export default __webpack_public_path__ + "static/media/reports-12.ab77d20e.png";